"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Hero = _ref => {
  let {
    className,
    children,
    sx,
    disableGutters,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.Box, _extends({
    sx: [{
      '& > *': {
        fontSize: 'large'
      }
    }, theme => ({
      ["".concat(theme.breakpoints.up('md'))]: {
        '& > *': {
          fontSize: 'larger'
        }
      }
    }), !disableGutters && {
      padding: 2
    }, sx]
  }, props), children);
};
Hero.defaultProps = {
  disableGutters: false
};
var _default = exports.default = Hero;